import { createEvent, restore, sample } from 'effector'
import { DemoContestClient, DemoContestClientRequest } from './types'
import { fx } from '../../../../libs'
import {
  isAllElementsOfSearchTextNotExist,
  mapSearchText,
} from '../../../../libs/utils'
import { $params } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'


export const demoContestClientListMounted =
  createEvent<DemoContestClientRequest>()

export const setDemoContestRequestError = createEvent<RequestError>()

export const getContestClients = fx<
  DemoContestClientRequest,
  DemoContestClient[]
>({
  method: 'GET',
  url: `/client_contests/by_client`,
})

export const $contestClients = restore<DemoContestClient[]>(
  getContestClients.doneData.map((a) => a.body),
  [],
)

export const $errorDemoContestRequest = restore(setDemoContestRequestError, {
  message: '',
  code: 0,
})

sample({
  // @ts-ignore
  clock: demoContestClientListMounted,
  source: $params,
  fn: (params, { sorterField, searchText }) => {
    let id

    if (params) {
      id = params.clientID
    }

    let query = {
      clientId: id,
    }

    if (sorterField) {
      // @ts-ignore
      query['order'] = sorterField
    }

    let newObj = {}

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getContestClients,
})

sample({
  clock: getContestClients.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setDemoContestRequestError],
})
